import api from "./api";

const EmailTemplateAPI = {
    getAll: () => api.get(`/email-templates/all`),
    getById: (id) => api.get(`/email-templates/details/${id}`),
    update: (params) => api.post(`/email-templates/update`, params),
    delete: (params) => api.post(`/email-templates/delete`, params),
};

export default EmailTemplateAPI;